import * as Sentry from '@sentry/react';
import { History, MemoryHistory } from 'history';
import { applyMiddleware, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { initMessageListener } from 'redux-state-sync';
import { getStoreConfig } from 'b2b-apps/shop/common/redux/utils';
import createRootReducer from './reducer';
import { State, Store } from './types';

type ConfiguredStoreType = {
  store: Store;
  history: History | MemoryHistory;
}

const configureStore = (
  url = '/',
  initialState: State = {},
): ConfiguredStoreType => {
  const sagaMiddleware = createSagaMiddleware();
  const { history, composeEnhancers, middlewares } = getStoreConfig(
    url,
    sagaMiddleware,
  );
  const sentryReduxEnhancer = Sentry.createReduxEnhancer();
  const store: Store = createStore(
    createRootReducer(history),
    initialState,
    composeEnhancers(applyMiddleware(...middlewares), sentryReduxEnhancer),
  );

  initMessageListener(store);

  store.runSaga = sagaMiddleware.run;

  return {
    history,
    store,
  };
};

export {
  configureStore,
};
